import { DestroyRef, Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '@auth0/auth0-angular';
import { logoutPortalUser } from './portal-auth-logout';

/**
 * Handles Auth0 authentication errors (e.g. expired/revoked refresh tokens).
 *
 * Subscribes to `AuthService.error$` — Auth0's official mechanism for
 * surfacing SDK-level failures. When the SDK cannot refresh the session,
 * it emits an error here, and we automatically log the user out.
 *
 * Inject this service in the portal shell to activate it.
 */
@Injectable({
  providedIn: 'root',
})
export class PortalAuthErrorHandler {
  private readonly auth = inject(AuthService);
  private readonly doc = inject(DOCUMENT);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.auth.error$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(_error => {
      void logoutPortalUser(this.auth, this.doc);
    });
  }
}
